import { http } from '../util/http'
import { fetchData } from '../util/index'
import { API_DOMAIN } from '../config'

// 获取七牛token
const getQiniuToken = () => {
  return new Promise((resolve, reject) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/getQiniuToken`
    fetchData(endpoint).then((data) => {
      resolve(data.token)
    })
  })
}

// 图片上传至七牛
export const uploadToQiniu = async (file) => {
  const token = await getQiniuToken()
  const form = new FormData()
  form.append('token', token)
  form.append('file', file)
  return http({
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    url: 'https://up-z0.qbox.me/',
    method: 'post',
    data: form,
    isFile: true
  })
}


// WEBPACK FOOTER //
// ./src/api/uploadImg.js